import React from 'react'
import _logo from '@/static/images/logo.svg'
import { imgURL } from '@/utils/countryVersion'

const logo = imgURL('./images/logo.svg') || _logo
const Loading = () => {
  return (
    <div style={{ position: 'relative', height: '100vh', width: '100vw' }}>
      <img src={logo} alt="pageloading" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: '40%', height: '40%' }} />
    </div>
  )
}

Loading.displayName = 'Loading'

export default Loading
